import {AbstractMapper} from '../../abstract.mapper';
import {PersonenTypEnum, PersonenTypEnumLabels, StammdatenBeteiligte} from '@nachdigal';
import {JuristischePersonMapperService} from './juristische-person-mapper.service';
import {InlandsadresseMapperService} from './inlandsadresse-mapper.service';
import {AuslandsadresseMapperService} from './auslandsadresse-mapper.service';
import {SteuernummerMapperService} from './steuernummer-mapper.service';
import {Injectable} from '@angular/core';

import {MappedStammdatenBeteiligte} from '@utils-lib';
import {PersonMapperService} from './person-mapper.service';
import {SteueridentifikationMapperService} from './steueridentifikation-mapper.service';

@Injectable()
export class BeteiligteMapperService extends AbstractMapper<StammdatenBeteiligte, MappedStammdatenBeteiligte> {

  constructor(
    private readonly natuerlichePersonMapper: PersonMapperService,
    private readonly juristischePersonMapper: JuristischePersonMapperService,
    private readonly inlandsadresseMapper: InlandsadresseMapperService,
    private readonly auslandsadresseMapper: AuslandsadresseMapperService,
    private readonly steuernummerMapper: SteuernummerMapperService,
    private readonly steueridentifikationMapperService: SteueridentifikationMapperService
  ) {
    super();
  }

  private static mapPersonenTyp(source: StammdatenBeteiligte): PersonenTypEnum {
    if (source.natuerlichePerson) {
      return PersonenTypEnumLabels.NatPers;
    }
    if (source.juristischePerson) {
      return PersonenTypEnumLabels.NNatPers;
    }
    return undefined;
  }

  protected mapInternal(source: StammdatenBeteiligte): MappedStammdatenBeteiligte {
    return {
      personenTyp: BeteiligteMapperService.mapPersonenTyp(source),
      natuerlichePerson: this.natuerlichePersonMapper.map(source.natuerlichePerson),
      juristischePerson: this.juristischePersonMapper.map(source.juristischePerson),
      inlandsadressen: this.inlandsadresseMapper.mapArrayWithDefault(source.adressen),
      auslandsadressen: this.auslandsadresseMapper.mapArrayWithDefault(source.adressen),
      steuernummer: this.steuernummerMapper.map(source.steuernummer),
      zeichnernummer: source.zeichnernummer,
      beteiligungBetrag: source.beteiligungBetrag,
      beteiligungProzent: source.beteiligungProzent,
      steueridentifikation: this.steueridentifikationMapperService.map(source.natuerlichePerson)
    };
  }
}
